import AppLayout from '@/views/layouts/AppLayout.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { menuRoutes } from './menu'
import { jwtDecode } from 'jwt-decode'
import type { InviteToken } from '@/model'

const dynamicFreeInviteLoader = () => {
  const token = window.location.search.split('t=')[1]

  let payload: any = ''

  try {
    payload = jwtDecode<InviteToken>(token)
  } catch {
    alert('The invitation is invalid')
  }

  const path = window.location.pathname
  const fairMasterCode = path.split('/')[1]?.toUpperCase()

  if (payload) {
    return import(`@/views/pages/invite/FreeInviteForm/FreeInviteForm_${payload?.LANG_TYPE}_${fairMasterCode}.vue`).catch(
      () => import(`@/views/pages/invite/FreeInviteForm_${payload?.LANG_TYPE}.vue`)
    )
  } else {
    return import('@/views/pages/invite/FreeInviteFail.vue')
  }
}

const router = createRouter({
  history: createWebHistory(initOptions.siteConfig?.basePath ?? '/'),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        ...menuRoutes,
        {
          path: '/account',
          component: () => import('@/views/pages/AccountPage.vue'),
          meta: {
            requiresAuth: true,
            title: '계정 정보'
          }
        }
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('@/views/pages/Join.vue')
    },
    { path: '/invitation', name: 'invitation', component: () => import('@/views/pages/InvitationCard.vue'), meta: { requireAuth: false } },
    {
      path: '/freeInvite',
      name: 'freeInvite',
      component: dynamicFreeInviteLoader,
      meta: { requireAuth: false }
    },
    { path: '/login', name: 'login', component: () => import('@/views/pages/Login.vue') },
    { path: '/find-account', name: 'find-account', component: () => import('@/views/pages/FindAccount.vue') },
    {
      path: '/:pathMatch(.*)*',
      name: 'notfound',
      component: () => import('@/views/pages/NotFound.vue')
    }
  ]
})

export default router
